// @ts-ignore -- Unused import
/* eslint-disable security/detect-object-injection */
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
// @ts-ignore -- Unused import
import { jsonLightReadStringPropertyValue } from '@msdyn365-commerce/retail-proxy/dist/externals';

/**
 * PahcPriceListLineEntity entity interface.
 */
export interface IPahcPriceListLineEntity {
    RecId: number;
    ItemNumber?: string;
    ItemDescription?: string;
    ShipFromCity?: string;
    ShipFromState?: string;
    QtyFrom?: string;
    UnitOfMeasure?: string;
    ContractPrice?: string;
    FobPrice?: string;
    DeliveredPrice?: string;
    OperationStatus?: string;
    CustomerNumber?: string;
    Msrp?: string;
    ShipToUniqueIdentifier?: string;
    ExtensionProperties?: Entities.CommerceProperty[];
    LotNumber?: string;
    JDEShortItemId?: string;
    PriceApplicableToDate?: Date | string;
    PriceApplicableFromDate?: Date | string;
}

/**
 * PahcPriceListShipToEntity entity interface.
 */
export interface IPahcPriceListShipToEntity {
    RecId: number;
    CustomerNumber?: string;
    ShipToUniqueIdentifier?: string;
    PriceApplicableFromDate?: string;
    PriceApplicableToDate?: string;
    CustomerCity?: string;
    CustomerState?: string;
    ExtensionProperties?: Entities.CommerceProperty[];
}

/**
 * PahcPriceListHeaderEntity entity interface.
 */
export interface IPahcPriceListHeaderEntity {
    RecId: number;
    CustomerNumber?: string;
    CustomerName?: string;
    RequestId?: string;
    PriceListLines?: IPahcPriceListLineEntity[];
    PriceListShipTos?: IPahcPriceListShipToEntity[];
    ExtensionProperties?: Entities.CommerceProperty[];
}

/**
 * PahcSalesLine entity interface.
 */
export interface IPahcSalesLine {
    ItemId?: string;
    LineId: number;
}

/**
 * PahcSalesOrderCancellationRequestEntity entity interface.
 */
export interface IPahcSalesOrderCancellationRequestEntity {
    SalesId?: string;
    SalesLines?: IPahcSalesLine[];
}

/**
 * PahcSalesOrderCancellationResponseEntity entity interface.
 */
export interface IPahcSalesOrderCancellationResponseEntity {
    Message?: string;
    Status: boolean;
}

/**
 * PahcSalesOrderAddProductRequestEntity entity interface.
 */
export interface IPahcSalesOrderAddProductRequestEntity {
    SalesId?: string;
    SalesLines?: IPahcSalesLine[];
}

/**
 * PahcAddProductToExistingSalesOrderResponseEntity entity interface.
 */
export interface IPahcAddProductToExistingSalesOrderResponseEntity {
    Message?: string;
    Status: boolean;
}

/**
 * PahcPriceListLineEntity entity class.
 */
export class PahcPriceListLineEntityExtensionClass implements IPahcPriceListLineEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public RecId: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ItemNumber: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ItemDescription: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ShipFromCity: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ShipFromState: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public QtyFrom: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public UnitOfMeasure: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ContractPrice: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public FobPrice: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public DeliveredPrice: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public OperationStatus: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CustomerNumber: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Msrp: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ShipToUniqueIdentifier: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ExtensionProperties: Entities.CommerceProperty[];

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore
    public LotNumber: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore
    public JDEShortItemId: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore
    public PriceApplicableFromDate: Date | string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore
    public PriceApplicableToDate: Date | string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore
    public ExtensionProperties: Entities.CommerceProperty[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.RecId = odataObject.RecId ? parseInt(odataObject.RecId, 10) : 0;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ItemNumber = odataObject.ItemNumber;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ItemDescription = odataObject.ItemDescription;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ShipFromCity = odataObject.ShipFromCity;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ShipFromState = odataObject.ShipFromState;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.QtyFrom = odataObject.QtyFrom;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.UnitOfMeasure = odataObject.UnitOfMeasure;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ContractPrice = odataObject.ContractPrice;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.FobPrice = odataObject.FobPrice;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.DeliveredPrice = odataObject.DeliveredPrice;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.OperationStatus = odataObject.OperationStatus;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CustomerNumber = odataObject.CustomerNumber;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Msrp = odataObject.Msrp;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ShipToUniqueIdentifier = odataObject.ShipToUniqueIdentifier;

        this.LotNumber = odataObject.LotNumber;

        this.JDEShortItemId = odataObject.JDEShortItemId;

        this.PriceApplicableFromDate = odataObject.PriceApplicableFromDate;

        this.PriceApplicableToDate = odataObject.PriceApplicableToDate;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ExtensionProperties = undefined;
        if (odataObject.ExtensionProperties) {
            this.ExtensionProperties = [];
            for (let i = 0; i < odataObject.ExtensionProperties.length; i++) {
                if (odataObject.ExtensionProperties[i]) {
                    if (odataObject.ExtensionProperties[i]['@odata.type']) {
                        const typeName: string = odataObject.ExtensionProperties[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.ExtensionProperties[i] = new EntityCtor(odataObject.ExtensionProperties[i]);
                        }
                    } else {
                        this.ExtensionProperties[i] = new EntityClasses.CommercePropertyClass(odataObject.ExtensionProperties[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.ExtensionProperties[i] = undefined;
                }
            }
        }
    }
}

/**
 * PahcPriceListShipToEntity entity class.
 */
export class PahcPriceListShipToEntityExtensionClass implements IPahcPriceListShipToEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public RecId: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CustomerNumber: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ShipToUniqueIdentifier: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public PriceApplicableFromDate: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public PriceApplicableToDate: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CustomerCity: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CustomerState: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ExtensionProperties: Entities.CommerceProperty[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.RecId = odataObject.RecId ? parseInt(odataObject.RecId, 10) : 0;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CustomerNumber = odataObject.CustomerNumber;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ShipToUniqueIdentifier = odataObject.ShipToUniqueIdentifier;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.PriceApplicableFromDate = odataObject.PriceApplicableFromDate;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.PriceApplicableToDate = odataObject.PriceApplicableToDate;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CustomerCity = odataObject.CustomerCity;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CustomerState = odataObject.CustomerState;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ExtensionProperties = undefined;
        if (odataObject.ExtensionProperties) {
            this.ExtensionProperties = [];
            for (let i = 0; i < odataObject.ExtensionProperties.length; i++) {
                if (odataObject.ExtensionProperties[i]) {
                    if (odataObject.ExtensionProperties[i]['@odata.type']) {
                        const typeName: string = odataObject.ExtensionProperties[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.ExtensionProperties[i] = new EntityCtor(odataObject.ExtensionProperties[i]);
                        }
                    } else {
                        this.ExtensionProperties[i] = new EntityClasses.CommercePropertyClass(odataObject.ExtensionProperties[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.ExtensionProperties[i] = undefined;
                }
            }
        }
    }
}

/**
 * PahcPriceListHeaderEntity entity class.
 */
export class PahcPriceListHeaderEntityExtensionClass implements IPahcPriceListHeaderEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public RecId: number;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CustomerNumber: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public CustomerName: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public RequestId: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public PriceListLines: IPahcPriceListLineEntity[];

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public PriceListShipTos: IPahcPriceListShipToEntity[];

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ExtensionProperties: Entities.CommerceProperty[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.RecId = odataObject.RecId ? parseInt(odataObject.RecId, 10) : 0;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CustomerNumber = odataObject.CustomerNumber;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.CustomerName = odataObject.CustomerName;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.RequestId = odataObject.RequestId;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.PriceListLines = undefined;
        if (odataObject.PriceListLines) {
            this.PriceListLines = [];
            for (let i = 0; i < odataObject.PriceListLines.length; i++) {
                if (odataObject.PriceListLines[i]) {
                    if (odataObject.PriceListLines[i]['@odata.type']) {
                        const typeName: string = odataObject.PriceListLines[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.PriceListLines[i] = new EntityCtor(odataObject.PriceListLines[i]);
                        }
                    } else {
                        this.PriceListLines[i] = new PahcPriceListLineEntityExtensionClass(odataObject.PriceListLines[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.PriceListLines[i] = undefined;
                }
            }
        }

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.PriceListShipTos = undefined;
        if (odataObject.PriceListShipTos) {
            this.PriceListShipTos = [];
            for (let i = 0; i < odataObject.PriceListShipTos.length; i++) {
                if (odataObject.PriceListShipTos[i]) {
                    if (odataObject.PriceListShipTos[i]['@odata.type']) {
                        const typeName: string = odataObject.PriceListShipTos[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.PriceListShipTos[i] = new EntityCtor(odataObject.PriceListShipTos[i]);
                        }
                    } else {
                        this.PriceListShipTos[i] = new PahcPriceListShipToEntityExtensionClass(odataObject.PriceListShipTos[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.PriceListShipTos[i] = undefined;
                }
            }
        }

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ExtensionProperties = undefined;
        if (odataObject.ExtensionProperties) {
            this.ExtensionProperties = [];
            for (let i = 0; i < odataObject.ExtensionProperties.length; i++) {
                if (odataObject.ExtensionProperties[i]) {
                    if (odataObject.ExtensionProperties[i]['@odata.type']) {
                        const typeName: string = odataObject.ExtensionProperties[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.ExtensionProperties[i] = new EntityCtor(odataObject.ExtensionProperties[i]);
                        }
                    } else {
                        this.ExtensionProperties[i] = new EntityClasses.CommercePropertyClass(odataObject.ExtensionProperties[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.ExtensionProperties[i] = undefined;
                }
            }
        }
    }
}

/**
 * PahcSalesLine entity class.
 */
export class PahcSalesLineExtensionClass implements IPahcSalesLine {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public ItemId: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public LineId: number;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.ItemId = odataObject.ItemId;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.LineId = odataObject.LineId ? parseFloat(odataObject.LineId) : 0;
    }
}

/**
 * PahcSalesOrderCancellationRequestEntity entity class.
 */
export class PahcSalesOrderCancellationRequestEntityExtensionClass implements IPahcSalesOrderCancellationRequestEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public SalesId: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public SalesLines: IPahcSalesLine[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.SalesId = odataObject.SalesId;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.SalesLines = undefined;
        if (odataObject.SalesLines) {
            this.SalesLines = [];
            for (let i = 0; i < odataObject.SalesLines.length; i++) {
                if (odataObject.SalesLines[i]) {
                    if (odataObject.SalesLines[i]['@odata.type']) {
                        const typeName: string = odataObject.SalesLines[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.SalesLines[i] = new EntityCtor(odataObject.SalesLines[i]);
                        }
                    } else {
                        this.SalesLines[i] = new PahcSalesLineExtensionClass(odataObject.SalesLines[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.SalesLines[i] = undefined;
                }
            }
        }
    }
}

/**
 * PahcSalesOrderCancellationResponseEntity entity class.
 */
export class PahcSalesOrderCancellationResponseEntityExtensionClass implements IPahcSalesOrderCancellationResponseEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Message: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Status: boolean;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Message = odataObject.Message;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Status = odataObject.Status;
    }
}

/**
 * PahcSalesOrderAddProductRequestEntity entity class.
 */
export class PahcSalesOrderAddProductRequestEntityExtensionClass implements IPahcSalesOrderAddProductRequestEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public SalesId: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public SalesLines: IPahcSalesLine[];

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.SalesId = odataObject.SalesId;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.SalesLines = undefined;
        if (odataObject.SalesLines) {
            this.SalesLines = [];
            for (let i = 0; i < odataObject.SalesLines.length; i++) {
                if (odataObject.SalesLines[i]) {
                    if (odataObject.SalesLines[i]['@odata.type']) {
                        const typeName: string = odataObject.SalesLines[i]['@odata.type'];
                        const className: string = typeName.substr(typeName.lastIndexOf('.') + 1).concat('Class');
                        // Dynamic lookup on generated entity classes; safe in this trusted context.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const EntityCtor = (EntityClasses as any)[className];
                        if (EntityCtor) {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                            this.SalesLines[i] = new EntityCtor(odataObject.SalesLines[i]);
                        }
                    } else {
                        this.SalesLines[i] = new PahcSalesLineExtensionClass(odataObject.SalesLines[i]);
                    }
                } else {
                    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
                    this.SalesLines[i] = undefined;
                }
            }
        }
    }
}

/**
 * PahcAddProductToExistingSalesOrderResponseEntity entity class.
 */
export class PahcAddProductToExistingSalesOrderResponseEntityExtensionClass implements IPahcAddProductToExistingSalesOrderResponseEntity {
    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Message: string;

    // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
    public Status: boolean;

    // Navigation properties names

    /**
     * Construct an object from odata response.
     * @param {any} odataObject The odata result object.
     */
    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Message = odataObject.Message;

        // @ts-ignore - TODO bug fix #23427261 - remove ts-ignore - https://microsoft.visualstudio.com/DefaultCollection/OSGS/_workitems/edit/23427261/
        this.Status = odataObject.Status;
    }
}
